export interface FieldErrorsDefinition {
  [errorCode: string]: string;
}
